import { AnimationSymbol, LayeredAnimationSymbol, SpineSymbol, StaticSymbol, SymbolBase, SymbolFactory } from "@quest/slot-core";
import { delayedCall, ingenuity, killDelayedCall } from "@quest/base-core";

import { ReelGame } from "../../ReelPanel/Reel";
import { gameConstants } from "../../Constants/gameConstants";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { HoldAndRespinModel } from "../Model/HoldAndRespinModel";
import { Graphics } from "@quest/pixi-bridge";

export class HoldAndReSpinReel extends ReelGame {
    protected model: HoldAndRespinModel;

    /**
     * Overrided to Pass arguments
     */
    constructor(reelId: number, rows: number, model: any, pool?: SymbolFactory) {
        super(reelId, rows, model, pool);
    }

    /**
     * Start loop
     */
    protected _startLoop(): void {
        if (this.model.getStoppedReels().indexOf(this.reelId) === -1) {
            this.spinNow = true;
        }
    }
    /**
     * Update prize feature spin
     */
    public updateSpin(deltaTime: number): void {
        if (!this.spinNow) {
            return;
        }
        let id: any | number[];
        let icon: StaticSymbol | AnimationSymbol | SpineSymbol | LayeredAnimationSymbol;
        let sym: any;
        if (this.initScroll >= this.model.getSymbolHeight()) {
            this.intLoopCounter++;
            this.initScroll = 0;
            let removeSymbolFromList: boolean = false;
            this.symCollection.forEach((symbol: SymbolBase, index: number) => {
                if (typeof symbol !== "undefined") {
                    icon = symbol.getStatic();
                    if (this.spinDirection === 1) {
                        symbol.setYPosition(symbol.y + this.model.getSymbolHeight() + (this.model.getSymbolSpacingY() || 0));
                        symbol.gridPosition++;
                    }
                    icon.visible = true;
                    symbol.forceHide = false;
                    if ((symbol.gridPosition > this.rows && this.spinDirection === 1) || (symbol.gridPosition < -1 && this.spinDirection === 0)) {
                        if (symbol.json.spinSym) {
                            const spinIcon: StaticSymbol | AnimationSymbol | SpineSymbol | LayeredAnimationSymbol = symbol.getSpinAnimation();
                            spinIcon.stopAnim();
                        }
                        symbol.returnToPool();
                        this.symCollection[index] = undefined;
                        removeSymbolFromList = true;
                    }
                }
            }, this);
            if (removeSymbolFromList) {
                const len: number = this.symCollection.length;
                for (let i: number = len - 1; i >= 0; i--) {
                    if (typeof this.symCollection[i] === "undefined") {
                        this.symCollection.splice(i, 1);
                    }
                }
            }
            if (Array.isArray(this.stops) && this.stops.length > 0 && this.intLoopCounter >= this.intMaxLoops) {
                if (this.spinDirection === 1) {
                    id = this.stops[this.stopIndex - 1];
                    sym = this.iconsPool.getSymbol(id as number);
                    this.symCollection.unshift(sym);
                    sym.gridPosition = -1;
                    this.stopIndex--;
                }
                icon = sym.getStatic();
                icon.visible = true;
                if (ingenuity.configData.decreaseSpinSpeed) {
                    if (this.model.json.decSpinSpeed) {
                        this.initSpinSpeed = (this.initSpinSpeed > this.model.json.minSpeed) ? this.initSpinSpeed - this.model.json.decSpinSpeed : this.model.json.minSpeed;
                    } else {
                        this.initSpinSpeed--;
                    }
                    this.quickSpinSpeed--;
                }
            } else {
                if (this.spinDirection === 1) {
                    id = this.model.getCurrentReelset()[this.reelId][this.index];
                    sym = this.iconsPool.getSymbol(id);
                    this.symCollection.unshift(sym);
                    sym.gridPosition = -1;
                }
                icon = sym.getStatic();
                icon.visible = true;
            }
            let yPos: number = 0;
            if (this.spinDirection === 1) {
                yPos = -this.model.getSymbolHeight() - (this.model.getSymbolSpacingY() || 0);
            }
            sym.setYPosition(yPos);
            sym.parent = this;
            this.addChildAt(icon, 0);
            if ((this.spinDirection === 1 && this.stopIndex === 0) || (this.spinDirection === 0 && this.stopIndex === (this.rows + 2))) {
                this.stopSpinNow = true;
            }
        }
        this.allignYWithDevice()
        let delta: number = deltaTime / this.desiredFPSTime, speed, qSpeed;
        if (delta > 1) {
            qSpeed = this.quickSpinSpeed * delta;
            speed = this.initSpinSpeed * delta;
        } else {
            qSpeed = this.quickSpinSpeed;
            speed = this.initSpinSpeed;
        }
        if (this.model.quickSpin) {
            this.initScroll += qSpeed + this.anticipationSpeed;
        } else {
            this.initScroll += speed + this.anticipationSpeed;
        }
        if (ingenuity.configData.hasOverlaySymbols) {
            this.sortIconsOnType();
        }
        if (this.stopSpinNow) {
            this.spinNow = false;
            this.handleReelStop();
            if (!this.model.noStopBounce) {
                this.showReelBounce()
            } else {
                delayedCall("stopReel", 10, this.spinDone, this);
            }
        }
    }
    /**
     * function will allign y value for spin
     * will allign both reels according to landscape and portrait
     */
    private allignYWithDevice(): void {
        // if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
        //     this.y = this.model.reelJson[this.reelId].portraitY + this.initScroll;
        // } else {
            this.y = this.model.reelJson[this.reelId].y + this.initScroll;
        // }
    }

    /**
     * This method is use to show reel bounce
     */
    private showReelBounce(): void {
        const stopBounceAmt: number = gameConstants.STOP_RESPIN_BOUNCE;
        const stopBounceTime: number = gameConstants.STOP_RESPIN_BOUNCE_TIME;
        const stopBounceTimeout: number = gameConstants.STOP_RESPIN_BOUNCE_TIMEOUT;
        let stopPos: number;
        // if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
        //     stopPos = this.model.reelJson[this.reelId].portraitY
        // } else {
            stopPos = this.model.reelJson[this.reelId].y
        //}
        const bounce: any = this.game.add.tween(this);
        bounce.to({ y: this.y + stopBounceAmt }, stopBounceTime, ingenuity.configData.reelStopBounceInEase, false);
        bounce.to({ y: stopPos }, stopBounceTimeout, ingenuity.configData.reelStopBounceOutEase, false);
        bounce.onComplete.add(this.spinDone, this);
        bounce.start();
    }

    /**
     * Spin done call
     */
    protected spinDone() {
        killDelayedCall("stopReel")
        this.sortIconsOnType();
        this.getStaticByPos(-1).visible = ingenuity.configData.showTopSymbol;
        if (this.children.length > this.rows + 1) {
            this.getStaticByPos(this.rows).visible = ingenuity.configData.showBottomSymbol;
        }
        this.initScroll = 0;
        this.intLoopCounter = 0;
        this.intMaxLoops = this.model.reelJson[this.reelId].maxLoops || this.rows + 2;
        this.anticipationSpeed = 0;
        this.initSpinSpeed = Array.isArray(this.model.spinSpeed) ? this.model.spinSpeed[this.reelId] : this.model.spinSpeed;
        this.quickSpinSpeed = Array.isArray(this.model.quickSpinSpeed) ? this.model.quickSpinSpeed[this.reelId] : this.model.quickSpinSpeed;
        this.stopSpinNow = false;
        this.spinNow = false;
        this.stopIndex = null;
        (typeof this.stops === "undefined") ? this.stops = [] : this.stops.length = 0;
        this.isSpinning = false;
        if (this.game.tweens.isTweening(this)) {
            this.game.tweens.removeFrom(this);
        }
        this.fireEvent(eventDispatchers.FEATURE_REEL_STOPPED, this.reelId);

    }
    /**
         * creates a reel mask to hide the extra top and bottom symbols.
         *
         */
    public reelMaskOn() {
        if (Array.isArray(this.model.json.mask) && this.model.json.mask[0].toLowerCase() === "reel" ||
        typeof this.model.json.mask === "string" && this.model.json.mask.toLowerCase() === "reel") {
            if (!(this.mask as Graphics)) {
                (this.mask as Graphics) = new Graphics(this.game, this.x + (this.model.json.offsetX || 0), this.y + (this.model.json.offsetY || 0));
                (this.mask as Graphics).beginFill(0xf00);
                (this.mask as Graphics).drawRect(0, 0, this.model.reelJson[this.reelId].w || this.width, this.model.reelJson[this.reelId].h || this.height);
                 this.parent?.addChild((this.mask as Graphics));
            }
        }
    }
    /**
     * to make all reels spinning false , 
     * handled a scenario where lockced reels changes
     */
    public stopAllReelSpinning():void{
        this.isSpinning = false;
    }
}